import { configureStore } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { combineReducers } from 'redux'

import appWindow from '@utils/AppWindow/app-window.slice'
import cookies from '@utils/Cookies/cookies.slice'
import login from '@App/pages/Login/login.slice'
import missionSetup from '@App/pages/MissionSetup/mission-setup.slice'
import alerts from '@App/pages/Alerts/alerts.slice'
import mosquitoDetection from '@App/pages/MosquitoObservations/mosquito-observations.slice'
import labResults from '@App/pages/LabResults/lab-results.slice'

export const RESET_STATE = 'RESET_STATE'

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['missionSetup'],
}

const combinedReducer = combineReducers({
  appWindow,
  cookies,
  login,
  alerts,
  missionSetup,
  mosquitoDetection,
  labResults,
})

const rootReducer = (state, action) => {
  if (action.type === RESET_STATE) {
    state = undefined
  }
  return combinedReducer(state, action)
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

const createStoreArgs = []

if (import.meta.env.DEV) {
  const { createLogger } = await import('redux-logger')
  const logger = createLogger({
    collapsed: (_getState, _action, logEntry) => !logEntry.error,
  })
  createStoreArgs.push(logger)
}

const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: ['persist/PERSIST'],
    },
  }).concat(createStoreArgs),
})

const persistor = persistStore(store)

export { store, persistor }
export default store
